import { render, staticRenderFns } from "./ModalInstitution.vue?vue&type=template&id=35b9d348&scoped=true&lang=pug"
import script from "./ModalInstitution.vue?vue&type=script&lang=js"
export * from "./ModalInstitution.vue?vue&type=script&lang=js"
import style0 from "./ModalInstitution.vue?vue&type=style&index=0&id=35b9d348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b9d348",
  null
  
)

export default component.exports